module.exports = __webpack_public_path__ + "img/biaoti_ziyuan.4d679b04.png";